export const environment = {
  base_url: 'https://dev.service.atlpay.com',
  allowed_origin: 'https://dev.app.atlpay.com',
  redirection_url_for_payment_page:
    'https://dev.app.atlpay.com/assets/pmt/payment-status-page/payment-status.html',
  dataLimit: '20',
  production: false,
};
